import React, { useState, useEffect } from 'react'

import { TextWithLinks } from 'src/shared/components/ui/text-with-links'
import { useMyUserData } from 'src/shared/features/users/api/accounts/use-my-user'
import { useUserByUsername } from 'src/shared/features/users/api/accounts/use-user-by-username'

interface BiographySectionProps {
  username: string
  charLimit?: number
  showReadMore?: boolean
}

const MOBILE_CHAR_LIMIT = 200
const DESKTOP_CHAR_LIMIT = 500

const BiographySection: React.FC<BiographySectionProps> = ({
  username,
  charLimit = DESKTOP_CHAR_LIMIT,
  showReadMore = true,
}) => {
  const { data: userData } = useUserByUsername(username)
  const { data: me } = useMyUserData()
  const [isExpanded, setIsExpanded] = useState(false)
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768)

  const isMyProfile = me?.username === username

  const user = isMyProfile ? me : userData

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768)
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  if (!user?.biography) return null

  if (!charLimit) {
    charLimit = isMobile ? MOBILE_CHAR_LIMIT : DESKTOP_CHAR_LIMIT
  }

  if (!showReadMore) {
    charLimit = user.biography.length
  }

  const shouldTruncate = user.biography.length > charLimit

  const displayText = isExpanded ? user.biography : user.biography.slice(0, charLimit)

  return (
    <div className="max-w-full leading-[160%] text-muted [word-break:break-word]">
      <TextWithLinks text={displayText} />
      {!isExpanded && shouldTruncate && '...'}
      {shouldTruncate && showReadMore && (
        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="ml-1 font-bold text-primary underline hover:text-primary/80"
        >
          {isExpanded ? 'Show less' : 'Read more'}
        </button>
      )}
    </div>
  )
}

export default BiographySection
